import * as actionType from './HoldCoType';

export const getHoldCoListRequest = (data) => ({
    type: actionType.GET_HOLDCO_LIST_REQUEST,
    payload: data,
});
export const getHoldCoListSuccess = (data) => ({
    type: actionType.GET_HOLDCO_LIST_SUCCESS,
    payload: data,
});
export const getHoldCoListFailure = (error) => ({
    type: actionType.GET_HOLDCO_LIST_FAILURE,
    payload: error,
});

// For get by id (edit)
export const getHoldCoByIdRequest = (id) => ({
    type: actionType.GET_HOLDCO_BY_ID_REQUEST,
    payload: id,
});
export const getHoldCoByIdSuccess = (data) => ({
    type: actionType.GET_HOLDCO_BY_ID_SUCCESS,
    payload: data,
});
export const getHoldCoByIdFailure = (error) => ({
    type: actionType.GET_HOLDCO_BY_ID_FAILURE,
    payload: error,
});

// For delete
export const deleteHoldCoRequest = (id) => ({
    type: actionType.DELETE_HOLDCO_REQUEST,
    payload: id,
});
export const deleteHoldCoSuccess = (data) => ({
    type: actionType.DELETE_HOLDCO_SUCCESS,
    payload: data,
});
export const deleteHoldCoFailure = (error) => ({
    type: actionType.DELETE_HOLDCO_FAILURE,
    payload: error,
});
export const resetDeleteState = () => ({
    type: actionType.RESET_DELETE_STATE,
});

// For delete file
export const deleteHoldCoFileRequest = (fileMappingId) => ({
    type: actionType.DELETE_HOLDCO_FILE_REQUEST,
    payload: fileMappingId,
});
export const deleteHoldCoFileSuccess = (data) => ({
    type: actionType.DELETE_HOLDCO_FILE_SUCCESS,
    payload: data,
});
export const deleteHoldCoFileFailure = (error) => ({
    type: actionType.DELETE_HOLDCO_FILE_FAILURE,
    payload: error,
});

// For save
export const saveHoldCoRequest = (data) => ({
    type: actionType.SAVE_HOLDCO_REQUEST,
    payload: data,
});
export const saveHoldCoSuccess = (data) => ({
    type: actionType.SAVE_HOLDCO_SUCCESS,
    payload: data,
});
export const saveHoldCoFailure = (error) => ({
    type: actionType.SAVE_HOLDCO_FAILURE,
    payload: error,
});
export const resetSaveState = () => ({
    type: actionType.RESET_SAVE_STATE,
});
